import { createContext, useContext } from "react";

import type { ActiveContext } from "shared/ContextSwitcher/store";
import type { SessionWithUser } from "src/utils/users/types";

interface ContextValue {
  session: SessionWithUser;
  activeContext: ActiveContext;
}

const LoggedInContext = createContext<undefined | ContextValue>(undefined);

export function LoggedInContextProvider(props: {
  value: ContextValue;
  children: React.ReactNode;
}) {
  return (
    <LoggedInContext.Provider value={props.value}>
      {props.children}
    </LoggedInContext.Provider>
  );
}

export function useLoggedInContext(): ContextValue {
  const contextValue = useContext(LoggedInContext);

  if (contextValue === undefined) {
    throw Error("Attempted to use LoggedInContext outside it's provider!");
  }

  return contextValue;
}
